<template>
  <div class="search-block border-bottom-divide">
    <span class="label condition-title">筛选条件</span>
    <div class="condition-part">
      <div class="condition-item">
        <span class="label keyword-label">风口类型</span>
        <el-select
            class="select-input"
            v-model="searchObj.structuresCode"
            placeholder="请选择"
            :disabled="from === 'AirOutletOthers'"
            @change="(value) => selectStructures(value)"
        >
          <el-option
              v-for="v in structures"
              :key="v.code"
              :label="v.name"
              :value="v.code"
          />
        </el-select>
      </div>
      <div class="condition-item">
        <span class="label keyword-label">品牌</span>
        <el-select
            class="select-input"
            v-model="searchObj.brandCode"
            placeholder="不限"
            :disabled="from === 'AirOutletOthers' || !isSphericalDiffuser"
            @change="(value) => selectSeries(value)"
        >
          <el-option label="不限" value="" />
          <el-option
              v-for="v in brands"
              :key="v.brandCode"
              :label="v.brandName"
              :value="v.brandCode"
          />
        </el-select>
      </div>
      <div class="condition-item">
        <span class="label keyword-label">出风口风速控制</span>
        <el-input
            class="narrow"
            v-model="searchObj.fromVelocity"
            ref="fromVelocity"
            @blur="fromVelocityChange"
            oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{8,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{8}).*$/g,'$1')"
        >
          <template #append>m/s</template>
        </el-input>
        <span> ~ </span>
        <el-input
            class="narrow"
            v-model="searchObj.toVelocity"
            ref="toVelocity"
            @blur="toVelocityChange"
            oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{8,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{8}).*$/g,'$1')"
        >
          <template #append>m/s</template>
        </el-input>
      </div>
      <div class="condition-item">
        <span class="label keyword-label">喷口射程</span>
        <el-input
            class="narrow"
            @blur="nozzleThrowChange"
            v-model="searchObj.nozzle_throw"
            ref="nozzle_throw"
            :disabled="!isSphericalDiffuser"
            oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{8,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{8}).*$/g,'$1')"
        >
          <template #append>m</template>
        </el-input>
      </div>
      <div class="condition-item">
        <span class="label keyword-label">长宽比</span>
        <el-input
            class="narrow"
            style="width: 40px"
            v-model="searchObj.aspectRatioFrom"
            ref="aspectRatioFrom"
            @blur="fromDiameterChange"
            :disabled="!isSingleLayer"
            oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{8,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{8}).*$/g,'$1')"
        >
        </el-input>
        <span> ~ </span>
        <el-input
            class="narrow"
            style="width: 40px"
            v-model="searchObj.aspectRatioTo"
            ref="aspectRatioTo"
            @blur="toDiameterChange"
            :disabled="!isSingleLayer"
            oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{8,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{8}).*$/g,'$1')"
        >
        </el-input>
      </div>
      <div class="condition-item">
        <span class="label keyword-label">单个风口承担面积</span>
        <el-input
            class="narrow"
            @blur="singleUnitChange"
            v-model="searchObj.singleUnitResponsibilityArea"
            ref="singleUnitResponsibilityArea"
            :disabled="from === 'AirOutletOthers'"
            oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{8,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{8}).*$/g,'$1')"
        >
          <template #append>m²</template>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AirOutletSearch',
  props: {
    initValue: {
      type: Object,
      default() {
        return {
          structuresName: '方形散流器',
          structuresCode: 'V000167',
          brandName: '',
          brandCode: '',
          fromVelocity: 2,
          toVelocity: 4,
          nozzle_throw: 8,
          aspectRatioFrom: 1,
          aspectRatioTo: 3,
          singleUnitResponsibilityArea: 50,
        }
      }
    },
    from: {
      type: String,
      default: 'AirOutlet',
    }
  },
  data() {
    return {
      searchObj: this.initValue,
      // 是否为球形风口
      isSphericalDiffuser: this.initValue.structuresName === '球形喷口',
      isSingleLayer: ['单层百叶风口', '双层百叶风口'].includes(this.initValue.structuresName),
      g_c_default_condition: true,
      // 风口类型
      structures: [
        { name: '方形散流器', code: 'V000167' },
        { name: '圆形散流器', code: 'V000168' },
        { name: '单层百叶风口', code: 'V000169' },
        { name: '双层百叶风口', code: 'V000170' },
        { name: '球形喷口', code: 'V000164' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      brands: 'list/brands',
    }),
  },
  watch: {
    initValue(newVal) {
      this.searchObj = newVal ? { ...newVal } : {}
    }
  },
  methods: {
    // 品牌筛选
    selectSeries(brandCode) {
      if (!brandCode) {
        this.searchObj.brandName = ''
        this.searchObj.brandCode = ''
      } else {
        const item = this.brands.find((i) => i.brandCode === brandCode) || {}
        this.searchObj.brandName = item.brandName
        this.searchObj.brandCode = item.brandCode
      }
      this.g_c_default_condition = false
    },

    // 风口类型
    selectStructures(code) {
      const item = this.structures.find((i) => i.code === code) || {}
      this.searchObj.structuresName = item.name
      this.isSelectStructures = true
      this.isSphericalDiffuser = item.name === '球形喷口'
      this.isSingleLayer = item.name === '单层百叶风口' || item.name === '双层百叶风口'
      if (!this.isSphericalDiffuser) {
        this.searchObj.brandName = ''
        this.searchObj.brandCode = ''
      }
      this.g_c_default_condition = false
    },
    // 出风口风速最小值
    fromVelocityChange() {
      this.g_c_default_condition = false
      if (this.searchObj.fromVelocity === '0') {
        this.$message({
          message: '出风口风速不能为0',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.fromVelocity = ''
        this.$refs.fromVelocity.focus()
        return
      }
      if (!this.searchObj.fromVelocity) {
        this.$message({
          message: '出风口风速不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.fromVelocity.focus()
      } else if (Number(this.searchObj.fromVelocity) > Number(this.searchObj.toVelocity)) {
        this.$message({
          message: '最大值不能小于最小值',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.fromVelocity = ''
        this.$refs.fromVelocity.focus()
      }
    },

    // 出风口风速最大值
    toVelocityChange() {
      this.g_c_default_condition = false
      if (this.searchObj.toVelocity === '0') {
        this.$message({
          message: '出风口风速不能为0',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.toVelocity = ''
        this.$refs.toVelocity.focus()
        return
      }
      if (!this.searchObj.toVelocity) {
        this.$message({
          message: '出风口风速不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.toVelocity.focus()
      } else if (Number(this.searchObj.fromVelocity) > Number(this.searchObj.toVelocity)) {
        this.$message({
          message: '最大值不能小于最小值',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.toVelocity = ''
        this.$refs.toVelocity.focus()
      }
    },

    // 长宽比最小值
    fromDiameterChange() {
      this.g_c_default_condition = false
      if (this.searchObj.aspectRatioFrom === '0') {
        this.$message({
          message: '长宽比不能为0',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.aspectRatioFrom = ''
        this.$refs.aspectRatioFrom.focus()
        return
      }
      if (!this.searchObj.aspectRatioFrom) {
        this.$message({
          message: '长宽比不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.aspectRatioFrom.focus()
      } else if (Number(this.searchObj.aspectRatioFrom) > Number(this.searchObj.aspectRatioTo)) {
        this.$message({
          message: '最大值不能小于最小值',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.aspectRatioFrom = ''
        this.$refs.aspectRatioFrom.focus()
      }
    },

    // 长宽比最大值
    toDiameterChange() {
      this.g_c_default_condition = false
      if (this.searchObj.aspectRatioTo === '0') {
        this.$message({
          message: '长宽比不能为0',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.aspectRatioTo = ''
        this.$refs.aspectRatioTo.focus()
      }
      if (!this.searchObj.aspectRatioTo) {
        this.$message({
          message: '长宽比不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.aspectRatioTo.focus()
      } else if (Number(this.searchObj.aspectRatioFrom) > Number(this.searchObj.aspectRatioTo)) {
        this.$message({
          message: '最大值不能小于最小值',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.aspectRatioTo = ''
        this.$refs.aspectRatioTo.focus()
      }
    },

    // 喷口射程
    nozzleThrowChange() {
      this.g_c_default_condition = false
      if (this.searchObj.nozzle_throw === '0') {
        this.$message({
          message: '喷口射程不能为0',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.nozzle_throw = ''
        this.$refs.nozzle_throw.focus()
      }
      if (!this.searchObj.nozzle_throw) {
        this.$message({
          message: '喷口射程不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.nozzle_throw.focus()
      }
    },

    // 单个风口承担面积
    singleUnitChange() {
      this.g_c_default_condition = false
      if (this.searchObj.singleUnitResponsibilityArea === '0') {
        this.$message({
          message: '单个风口承担面积不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.searchObj.singleUnitResponsibilityArea = ''
        this.$refs.singleUnitResponsibilityArea.focus()
      }
      if (!this.searchObj.singleUnitResponsibilityArea) {
        this.$message({
          message: '单个风口承担面积不能为空',
          type: 'warning',
          offset: '200',
          duration: 1500,
          customClass: 'focus-message',
        })
        this.$refs.singleUnitResponsibilityArea.focus()
      }
    },

    // 获取搜索参数
    getSearchData() {
      return {
        searchData: this.searchObj,
        isSphericalDiffuser: this.isSphericalDiffuser,
        isSingleLayer: this.isSingleLayer,
        g_c_default_condition: this.g_c_default_condition,
      }
    }
  }
}
</script>

<style lang="less" scoped>
.search-block {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-top: 8px;
  .condition-title{
    width: 64px;
  }
  .condition-part{
    display: flex;
    flex-wrap: wrap;
  }
  .condition-item{
    margin-bottom: 8px;
  }
  .label {
    height: 24px;
    line-height: 24px;
  }
  .switch {
    margin: 4px 16px 4px 0;
  }
}
.select-input {
  width: 108px;
}
.keyword-label {
  margin: 0 6px 0 16px;
}
.search-label {
  margin-right: 8px;
}
.narrow {
  width: 73px;
}

/deep/.el-input__inner {
  height: 24px !important;
  line-height: 24px !important;
}
/deep/.el-input-number--mini {
  width: 116px;
  line-height: 22px;
}
/deep/.el-button {
  margin-left: 0 !important;
}
/deep/.el-button--text {
  color: #4897f5;
}
/deep/.focus-message {
  color: red !important;
  background: blue !important;
}
</style>
